



import {Component, Vue, Prop} from 'vue-property-decorator';
import SvgRender from "@/components/Atoms/SvgRender/SvgRender.vue";

@Component({
  components: {SvgRender}
})
export default class DeleteModal extends Vue {
  private check = true

  private closePopup(): void {
    this.check = !this.check
    this.$emit('onClickClosePopup')
  }

  private delItem(): void {
    this.$emit('onClickDel')
  }

}
